export const USER_ROLES = {
  USER_ROLE_MANAGE_BOXES: 'MANAGE_BOXES',
  USER_ROLE_MANAGE_COMPANY: 'MANAGE_COMPANY',
  USER_ROLE_MANAGE_MEMBERS: 'MANAGE_MEMBERS',
  USER_ROLE_MANAGE_SUB_ACCESS: 'MANAGE_SUB_ACCESS',
  USER_ROLE_ORDER_SUB: 'ORDER_SUB',
  USER_ROLE_VIEW_COMPANY: 'VIEW_COMPANY',
  USER_ROLE_VIEW_SUB: 'VIEW_SUB',
  USER_ROLE_VIEW_TOKEN: 'VIEW_TOKEN',
}

export const ORGANIZATION_ROLES = {
  ORGANIZATION_ROLE_OWNER: 'owner',
  ORGANIZATION_ROLE_MEMBER: 'member',
}
